export const SET_ICONS = "SET_ICONS"